export const TIMEOUT_LIMITS = {
  MIN_CONNECTION_SEND: 1,
  MAX_CONNECTION_SEND: 60,
  MIN_READ: 1,
  MAX_READ: 1800,
  DEFAULT_TIMEOUT: 5,
} as const;
